import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const notFoundRoute: RouteConfig<'with-page'> = {
    name: 'Error - 404',
    path: '/error/404',
    page: lazy(() => import('.')),
}